import { render, staticRenderFns } from "./lawService.vue?vue&type=template&id=3f70a266&scoped=true&"
import script from "./lawService.vue?vue&type=script&lang=js&"
export * from "./lawService.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/entity-org.css?vue&type=style&index=0&id=3f70a266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f70a266",
  null
  
)

export default component.exports